import {
  createTheme,
  Input,
  mergeThemeOverrides,
  MultiSelect,
  NumberInput,
  PasswordInput,
  RadioGroup,
  Select,
  TagsInput,
  Textarea,
  TextInput,
  Tooltip
} from "@mantine/core";
// eslint-disable-next-line no-restricted-imports
import { DateInput, DatePickerInput } from "@mantine/dates";
import { mantineTheme as baseMantineTheme } from "@node-energy/ne-theme";
// this still needs explicit React import to work properly in Storybook
import { THEME_VARS } from "../utils/constants";

const hideRequiredAsterisk = { styles: { required: { display: "none" } } };

const localOverrides = createTheme({
  colors: THEME_VARS,
  components: {
    DateInput: DateInput.extend(hideRequiredAsterisk),
    DatePickerInput: DatePickerInput.extend(hideRequiredAsterisk),
    InputWrapper: Input.Wrapper.extend(hideRequiredAsterisk),
    MultiSelect: MultiSelect.extend(hideRequiredAsterisk),
    NumberInput: NumberInput.extend(hideRequiredAsterisk),
    PasswordInput: PasswordInput.extend(hideRequiredAsterisk),
    RadioGroup: RadioGroup.extend(hideRequiredAsterisk),
    Select: Select.extend(hideRequiredAsterisk),
    TagsInput: TagsInput.extend(hideRequiredAsterisk),
    Textarea: Textarea.extend(hideRequiredAsterisk),
    TextInput: TextInput.extend(hideRequiredAsterisk),
    Tooltip: Tooltip.extend({ defaultProps: { hideDetached: false } })
  }
});

const mantineTheme = mergeThemeOverrides(baseMantineTheme, localOverrides);

export { mantineTheme };
